import type { UploadUrlRequest, UploadUrlResponse, ApiError } from "@mycv/shared";

const API_BASE = ""; // same-origin via CloudFront

export class TakenError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = "TakenError";
  }
}

export async function getUploadUrl(req: UploadUrlRequest): Promise<UploadUrlResponse> {
  const res = await fetch(`${API_BASE}/api/upload-url`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(req),
  });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const body = (await res.json()) as ApiError;
      if (body.error) msg = body.error;
    } catch { /* ignore */ }
    if (res.status === 409) throw new TakenError(msg);
    throw new Error(msg);
  }
  return res.json() as Promise<UploadUrlResponse>;
}

export interface PutProgress {
  loaded: number;
  total: number;
}

export function putFile(url: string, file: File, onProgress?: (p: PutProgress) => void): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url);
    xhr.setRequestHeader("Content-Type", file.type);
    xhr.upload.addEventListener("progress", (e) => {
      if (e.lengthComputable && onProgress) onProgress({ loaded: e.loaded, total: e.total });
    });
    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error(`upload failed: HTTP ${xhr.status}`));
    });
    xhr.addEventListener("error", () => reject(new Error("network error during upload")));
    xhr.send(file);
  });
}
